// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__2eoaz","total":"Cart_total__ply0b","actions":"Cart_actions__2neLp","button--alt":"Cart_button--alt__3J8qp","button":"Cart_button__3hw2J"};